import Boolean from "./Boolean";
import TextFieldEditor from "./TextFieldEditor";
import TextareaEditor from "./TextareaEditor";
import YesNo from "./YesNo";
import Double from "./Double";
import Integer from "./Integer";
import Dropdown from "./dropdown/Dropdown";
import LabelRender from "./Label";
import * as React from "react";
import { Label, Toggle } from "office-ui-fabric-react";
import { Field, FieldValue, FieldValues, Language } from "typings";
import DateTime from "./DateTime";
import File from "./File";
import Url from "./Url";
import Media from "./mediaPicker/Media";
import LocaleMedia from "./mediaPicker/LocaleMedia";
import CollectionPicker from "./collectionPicker";
import LocaleTextEditor from "./LocaleTextEditor";
import ProductPicker from "./productPicker";
import PropertyPicker from "./propertyPicker";
import LocaleTextareaEditor from "./localeTextareaEditor/LocaleTextareaEditor";
import Tags from "./Tags";

import CheckboxList from "./checkboxList";
import LocaleTextList from "./localeTextList";
import { MediaStylePicker } from "./fieldStyles";
import * as FieldValidate from "./FieldHelper";


const fieldRender = 
    (field: Field, 
    value: FieldValue<any>, 
    onValueChange: (value: FieldValues) => void, 
    languages: Language[], 
    onClearField?: () => void, 
    hasParent?: boolean) => 
    {
    let timer:number;
    const onValueChangeHandler = (value: FieldValues) =>
    {
        clearTimeout(timer);
        timer = window.setTimeout(() => onValueChange(value), 500);
    };

    const onInheritedChange = () =>
    {
        if (value && value.inherited)
        {
            let tempValue : any = value.value;
            if (value.value === undefined)
            {
                if (field.field.fieldType.id === "yesno" || field.field.fieldType.id === "checkbox")
                {
                    tempValue = false;
                }
                else if (field.field.fieldType.id === "double" || field.field.fieldType.id === "integer")
                {
                    tempValue = 0;
                }
                else if (field.field.fieldType.id === "media" || field.field.fieldType.id === "locale_media" || field.field.fieldType.id === "tags")
                {
                    tempValue = [];
                }
                else if (field.field.fieldType.id === "locale_text")
                {
                    tempValue = {};
                }
                else
                {
                    tempValue = "";
                }
            }
            const newValue = { value: tempValue };
            onValueChange(newValue as FieldValues);
        }
        else if (onClearField)
        {
            onClearField();
        }
    };
    let inherited = null;
        let disableEditor = false;
    if (hasParent && value && value.inheritedValue)
    {
        disableEditor = value && (value.inherited || false); 
        const enableInherit = value && value.inheritedValue;
        inherited = <Toggle offText={"Inherited"} onText={"Inherited"} onChange={onInheritedChange}
            checked={disableEditor} disabled={!enableInherit} />;
    }
   
    let editor = <div key={field.field.name}>Missing editor for {field.field.fieldType.id}</div>;
    if (FieldValidate.isCheckbox(field, value))
    {
        editor = <Boolean key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isYesNo(field, value))
    {
        editor = <YesNo key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isString(field, value))
    {
        editor = <TextFieldEditor key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isTextarea(field, value))
    {
        editor = <TextareaEditor key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isDouble(field, value))
    {
        editor = <Double key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isInteger(field, value))
    {
        editor = <Integer key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isDateTime(field, value))
    {
        editor = <DateTime key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isDropdown(field, value))
    {
        editor = <Dropdown key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isLabel(field, value))
    {
        editor = <LabelRender key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isFile(field, value))
    {
        return <File key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isYoutube(field, value))
    {
        return <Url key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isCheckBoxList(field, value))
    {
        editor = <CheckboxList key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isMediaPicker(field, value))
    {
        editor = <MediaStylePicker>
            <Media
                key={field.field.name}
                onValueChange={onValueChangeHandler}
                {...field} value={value}
                disabled={disableEditor} />
            </MediaStylePicker>;
    }
    if (FieldValidate.isLocaleMediaPicker(field, value))
    {
        editor = <MediaStylePicker>
            <LocaleMedia
                key={field.field.name}
                onValueChange={onValueChangeHandler}
                {...field}
                value={value}
                languages={languages}
                disabled={disableEditor} />
            </MediaStylePicker>;
    }
    if (FieldValidate.isCollectionPicker(field, value))
    {
        editor = <CollectionPicker  key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }
    if (FieldValidate.isProductPicker(field, value))
    {
        editor = <ProductPicker  key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }
    
    if (FieldValidate.isTags(field, value))
    {
        editor = <Tags key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }

    if (FieldValidate.isPropertyPicker(field, value))
    {
        editor = <PropertyPicker key={field.field.name} onValueChange={onValueChangeHandler} {...field} value={value} disabled={disableEditor} />;
    }
    
    if (FieldValidate.isLocaleTextarea(field, value))
    {
        editor = editor = <LocaleTextareaEditor 
            key={field.field.name} 
            onValueChange={onValueChangeHandler} 
            {...field} 
            value={value} 
            disabled={disableEditor} 
            languages={languages} />;
    }
    if (FieldValidate.isLocaleTextList(field, value))
    {
        editor = editor = <LocaleTextList 
            key={field.field.name} 
            onValueChange={onValueChangeHandler} 
            {...field} 
            value={value} 
            disabled={disableEditor} 
            languages={languages} />;
    }
    if (FieldValidate.isLocaleText(field, value))
    {
        editor = <LocaleTextEditor 
            key={field.field.name} 
            onValueChange={onValueChangeHandler} 
            {...field} 
            value={value} 
            disabled={disableEditor} 
            languages={languages} />;
    }
   
    return (
        <div key={field.field.name}>
            <Label>{field.field.label._DEFAULT}</Label> {inherited}
            {editor}
        </div>
    );
   
};

export default fieldRender;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/index.tsx